// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5608) return "static/chunks/5608-5211b6db3357ebfb.js";
	if (chunkId === 9334) return "static/chunks/9334-3f20346fced2ee02.js";
	if (chunkId === 8765) return "static/chunks/8765-73b335754a094ef9.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5381":"1d21e4d1e32a6468","5898":"ad25d6dbb9dafd3d","6691":"cef3dc84589ebb62"}[chunkId] + ".js";
};